import {useProductDetailsQuery} from "./useProductDetailsQuery";

export const useMediaGalleryQuery = () => {
    const {model: {media, youTubeVideos, primaryMedia, primaryYouTubeVideos}} = useProductDetailsQuery();

    const distinctImages = [
        ...media.images.raw,
        ...primaryMedia.images.raw
    ].filter((image, index, self) => index === self.findIndex((t) => t.url === image.url));

    const distinctVideos = [
        ...media.videos.productIntro,
        ...media.videos.productSeriesShowcase,
        ...media.videos.productOnly,
        ...media.videos.assemblyHowTo,
        ...primaryMedia.videos.productIntro,
        ...primaryMedia.videos.productSeriesShowcase,
        ...primaryMedia.videos.productOnly,
        ...primaryMedia.videos.assemblyHowTo
    ].filter((video, index, self) => index === self.findIndex((t) => t.url === video.url));

    const distinctYouTubeVideos = [
        ...youTubeVideos,
        ...primaryYouTubeVideos
    ].filter((image, index, self) => index === self.findIndex((t) => t.id === image.id));

    return {
        media: {
            internalCount: distinctImages.length + distinctVideos.length,
            images: {
                internal: distinctImages
            },
            videos: {
                internal: distinctVideos,
                external: distinctYouTubeVideos,
                externalCount: distinctYouTubeVideos.length
            }
        }
    };
}